<div class="loader-container">
    <app-loader *ngIf="loading == true"></app-loader>
    <app-modal-header *ngIf="modalStyle === true" [title]="modalTitle"></app-modal-header>
    <div [ngClass]="{
        'modal-body': modalStyle === true
    }">
        <div *ngIf="errorMessage && errorMessage.length" class="alert alert-danger d-flex align-items-center" role="alert">
            <div>
                {{errorMessage}}
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-6">
                <label class="form-label">Naam</label> 
                <input 
                    [ngClass]="{'is-invalid': errors['name']}"
                    type="text" 
                    [(ngModel)]="item['name']" 
                    class="form-control" 
                    placeholder="">
            </div>
            <div class="col-6">
                <label class="form-label">Code</label> 
                <input 
                    [ngClass]="{'is-invalid': errors['code']}"
                    type="text" 
                    [(ngModel)]="item['code']" 
                    class="form-control" 
                    placeholder="">
            </div>
        </div>

        <div class="form-buttons">
		    <button type="button" class="btn btn-primary" (click)="save()">
                <span *ngIf="item['id']">Toevoegen</span>
                <span *ngIf="!item['id']">Opslaan</span>
            </button>
        </div>
    </div>
</div>